var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.575195 18C0.575195 27.9411 8.63407 36 18.5752 36C28.5163 36 36.5752 27.9411 36.5752 18C36.5752 8.05888 28.5163 0 18.5752 0C8.63407 0 0.575195 8.05888 0.575195 18Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8252 18C29.8252 11.8125 24.7627 6.75 18.5752 6.75C12.3877 6.75 7.3252 11.8125 7.3252 18C7.3252 23.625 11.4033 28.2656 16.7471 29.1094V21.2344H13.9346V18H16.7471V15.4688C16.7471 12.6562 18.4346 11.1094 20.9658 11.1094C22.2314 11.1094 23.4971 11.3906 23.4971 11.3906V14.2031H22.0908C20.6846 14.2031 20.2627 15.0469 20.2627 15.8906V18H23.3564L22.7939 21.2344H20.1221V29.25C25.7471 28.4062 29.8252 23.625 29.8252 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbNewLogo);
export default __webpack_public_path__ + "static/media/fbNewLogo.beb16532d0d8fb509173bd82019d52f8.svg";
export { ForwardRef as ReactComponent };